<div fxLayout="column" fxLayoutAlign="start start" class="w-100">
    @if (label) {
        <div class="t5 c-primary-gray-600">{{ label | translate }} {{ control?.hasValidator(Validators.required) ? '*' : '' }}</div>
    }
    <mat-form-field class="w-100"
                    [class.mt-4]="label"
                    [class.value-not-empty]="isValidIp(control?.value)">
        <input matInput
               mask="IP"
               [validation]="false"
               [dropSpecialCharacters]="false"
               [formControl]="control"
               [placeholder]="placeholder | translate"
               [name]="name"/>
        @if (control?.hasError('required')) {
            <mat-error class="c-secondary-red-900">
                {{ 'i18n_af_fieldValidationRequired' | translate }}
            </mat-error>
        }
        @if (control?.hasError('invalidIp')) {
            <mat-error class="c-secondary-red-900">
                {{ 'i18n_af_fieldValidationInvalidIp' | translate }}
            </mat-error>
        }
    </mat-form-field>
</div>
